import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@core/services/authentication/auth.service';
import { MomentService } from '@core/services/moment.service';
import { WebEngageRepository } from '@core/services/repositories/webEngage.repository';
import { WebengageService } from '@core/services/webengage.service';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';

@Component({
 selector: 'iho-dumping-modal',
 templateUrl: './dumping-modal.component.html',
 styleUrls: ['./dumping-modal.component.scss'],
})
export class DumpingModalComponent {
 phoneNumber = new FormControl('');
 loading = false;
 cdnUrl = cdnUrl;

 destroyRef = inject(DestroyRef);

 constructor(
  @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DumpingModalComponent>,
  private webEngageRepo: WebEngageRepository,
  private webengageService: WebengageService,
  private AuthService: AuthService,
  private route: ActivatedRoute,
  private momentService: MomentService
 ) {}

 letMeKnow() {
  if (this.phoneNumber.value && this.phoneNumber.valid && !this.loading) {
   this.loading = true;
   this.webEngageRepo.saveDumpingMobile(this.phoneNumber.value).subscribe((res) => {
    if (this.AuthService._isAuthenticated()) {
     if (this.AuthService.getUserData()().Mobile !== this.phoneNumber.value && res.Result) {
      this.webengageService.userLogout();
      this.webengageService.userLogin(res.Message);
      this.webengageService.userSetAttribute('we_phone', this.phoneNumber.value);
      this.webengageService.track('campagain form', {
       status: 'completed',
       mobile: this.phoneNumber.value ?? '',
       firstName: this.AuthService.getUserData()().FirstName ?? '',
       lastName: this.AuthService.getUserData()().LastName ?? '',
      });
      this.webengageService.userLogout();
      this.AuthService.sendUserLoginEvent();
     } else {
      this.webengageService.track('campagain form', {
       status: 'completed',
       discountName: this.route?.snapshot?.queryParams?.['utm_campaign'],
       campaignTag: this.route?.snapshot?.queryParams?.['utm_source'],
       mobile: this.AuthService.getUserData()().Mobile,
       firstName: this.AuthService.getUserData()().FirstName,
       lastName: this.AuthService.getUserData()().LastName,
      });
     }
     this.dialogRef.close();
    }
   });
  }
 }
}
